import { RxCollectionCreator } from 'rxdb';

export const meetingTypeSchema: RxCollectionCreator = {
	schema: {
		title: 'Meeting type  schema',
		description: 'create a Meeting Type  schema',
		version: 1,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: { type: 'string', maxLength: 200 },
			name: { type: 'string' },
			townmetro_c: { type: ['number', 'null'] },
			townminimetro_c: { type: ['number', 'null'] },
			townclassa_c: { type: ['number', 'null'] },
			townclassb_c: { type: ['number', 'null'] },
			townclassc_c: { type: ['number', 'null'] },
			minattendees_c: { type: ['number', 'null'] },
			maxattendees_c: { type: ['number', 'null'] },
		},
		required: [
			'id',
			'name',
			'sfid',
			'townmetro_c',
			'townminimetro_c',
			'townclassa_c',
			'townclassb_c',
			'townclassc_c',
			'minattendees_c',
			'maxattendees_c',
		],
	},
	migrationStrategies: {
		1: async (oldDoc) => {
			return {
				...oldDoc,
			};
		},
	},
};
